@let ticket = selectedTicket();
<div class="flex h-full min-h-0 flex-col">
  <div
    class="sortiment-edit-header mb-4 flex h-10 shrink-0 items-center justify-between gap-4">
    <div class="flex min-w-0 items-center gap-3 overflow-hidden">
      <aw-section-headline class="block shrink-0" size="medium">
        {{ ticket?.name ?? cmsTextProvider.sortiment.defaultProductName }}
      </aw-section-headline>
      @if (ticket) {
        <div class="ticket-labels flex shrink-0 items-center gap-3">
          <aw-chip
            class="ticket-type-label [&_.material-symbols-rounded]:text-xl! [&>div]:min-h-8! [&>div]:gap-1.5! [&>div]:px-3! [&>div]:py-1! [&>div]:text-base!"
            [id]="ticket.ticketType + '-chip'"
            appearance="neutral"
            [icon]="getTicketSortIcon(ticket.ticketType)"
            [text]="ticket.ticketType" />
          @if (!isTicketLayoutCompleted()) {
            <aw-chip
              class="layout-incomplete-label [&_.material-symbols-rounded]:text-xl! [&>div]:min-h-8! [&>div]:gap-1.5! [&>div]:px-3! [&>div]:py-1! [&>div]:text-base!"
              [id]="ticket.name + '-layout-incompletion-chip'"
              appearance="warning"
              icon="warning"
              [text]="cmsTextProvider.sortiment.layoutIncomplete" />
          }
        </div>
      }
    </div>

    @if (ticket) {
      <div class="flex shrink-0 items-center gap-3">
        <aw-button
          class="[&>button]:h-10! [&>button]:px-3! [&>button]:py-2! [&>button]:text-base!"
          [id]="ticket.name + '-reset-all'"
          type="button"
          [style]="'error-alt'"
          buttonSize="small"
          (click)="resetTicket.emit()">
          {{ cmsTextProvider.sortiment.resetAll }}
        </aw-button>
        @if (ticket.ticketType !== 'Abonnement') {
          <aw-button
            class="[&>button]:text-primary-main [&>button]:h-10! [&>button]:px-3! [&>button]:py-2! [&>button]:text-base!"
            [id]="ticket.name + '-layouts'"
            type="button"
            [style]="'primary-alt'"
            buttonSize="small"
            (click)="openLayoutAssignmentDialog()">
            <span
              class="material-symbols-rounded mr-1.5 text-xl! leading-none"
              aria-hidden="true">
              confirmation_number
            </span>
            {{ cmsTextProvider.sortiment.layouts }}
            @if (unassignedLayoutTicketCount() > 0) {
              <span
                class="bg-warning-main/40 text-warning-on ml-2 flex h-6 min-w-6 items-center justify-center rounded-full px-1 text-sm font-semibold">
                {{ unassignedLayoutTicketCount() }}
              </span>
            }
          </aw-button>
        }
      </div>
    }
  </div>
  <aw-section
    class="block min-h-0 flex-1 overflow-y-auto"
    testIdAffix="sortiment-edit">
    <aw-section-headline class="block shrink-0" size="small">
      {{ cmsTextProvider.shared.image }}
    </aw-section-headline>
    <aw-checkbox
      id="display-image"
      [formControl]="ticketForm().controls.displayImage"
      [label]="cmsTextProvider.sortiment.displayImage" />
    <div class="flex w-full items-start gap-4">
      <aw-image-select
        id="image-source"
        [formControl]="ticketForm().controls.accessibleImage.controls.image"
        [label]="cmsTextProvider.sortiment.imageSource"
        usageLabel="ticket.image"
        [persistUsageOnSelect]="true" />
      <aw-translation-accessibility-text-input
        id="accessible-image"
        [entityType]="EntityType.ticket"
        [relationType]="TextRelationType.imageAlt"
        [formControl]="ticketForm().controls.accessibleImage.controls.imageAlts"
        [label]="cmsTextProvider.sortiment.description" />
    </div>
    <aw-section-headline class="block shrink-0" size="small">
      {{ cmsTextProvider.sortiment.generalInformations }}
    </aw-section-headline>
    <aw-translation-text-input
      class="block w-full"
      id="ticket-title"
      [entityType]="EntityType.ticket"
      [relationType]="TextRelationType.title"
      [formControl]="ticketForm().controls.title"
      [label]="cmsTextProvider.shared.title" />
    <aw-checkbox
      id="display-price"
      [formControl]="ticketForm().controls.displayPrice"
      [label]="cmsTextProvider.sortiment.displayPrice" />
    <aw-translation-text-editor
      class="block min-w-0 [&_.ql-editor]:[overflow-wrap:anywhere]"
      id="ticket-description"
      [entityType]="EntityType.ticket"
      [relationType]="TextRelationType.description"
      [formControl]="ticketForm().controls.description"
      [label]="cmsTextProvider.shared.description" />
    <aw-section-headline class="block shrink-0" size="small">
      {{ cmsTextProvider.sortiment.detailInformations }}
    </aw-section-headline>
    <div class="w-1/2">
      <aw-translation-text-input
        class="block w-full"
        id="ticket-details-title"
        [entityType]="EntityType.ticket"
        [relationType]="TextRelationType.detailsTitle"
        [formControl]="ticketForm().controls.detailsTitle"
        [label]="cmsTextProvider.sortiment.nameOfAdditionalDisplay" />
    </div>

    <div class="flex flex-col gap-6">
      @for (
        detail of ticketForm().controls.details.controls;
        track detail;
        let index = $index
      ) {
        <div
          class="grid grid-cols-[24px_180px_minmax(0,1fr)_40px] items-start gap-3"
          [formGroup]="detail">
          <div class="flex min-h-12 flex-col items-center justify-center">
            <button
              type="button"
              class="text-primary-main flex h-6 cursor-pointer items-center disabled:cursor-default disabled:opacity-40"
              [disabled]="index === 0"
              [attr.aria-label]="'Detail ' + (index + 1) + ' nach oben'"
              (click)="moveDetail(index, index - 1)">
              <span class="material-symbols-rounded text-xl!">
                keyboard_arrow_up
              </span>
            </button>
            <button
              type="button"
              class="text-primary-main flex h-6 cursor-pointer items-center disabled:cursor-default disabled:opacity-40"
              [disabled]="
                index === ticketForm().controls.details.controls.length - 1
              "
              [attr.aria-label]="'Detail ' + (index + 1) + ' nach unten'"
              (click)="moveDetail(index, index + 1)">
              <span class="material-symbols-rounded text-xl!">
                keyboard_arrow_down
              </span>
            </button>
          </div>

          <aw-icon-picker
            class="block w-full"
            [id]="'ticket-detail-icon-' + index"
            [formControl]="detail.controls.icon" />
          <aw-translation-text-editor
            class="block w-full"
            [id]="'ticket-detail-text-' + index"
            [entityType]="EntityType.ticket"
            [relationType]="TextRelationType.text"
            [formControl]="detail.controls.texts"
            [label]="cmsTextProvider.shared.text" />

          <aw-button
            class="[&>button]:h-12 [&>button]:w-10 [&>button]:p-0"
            [id]="'delete-ticket-detail-' + index"
            type="button"
            [style]="'error-alt'"
            buttonSize="quadratic"
            (click)="removeDetail(index)">
            <span class="material-symbols-rounded text-xl!" aria-hidden="true">
              delete
            </span>
          </aw-button>
        </div>
      }

      <aw-button
        class="blue w-fit [&>button]:text-sm [&>button]:text-[#0066CC]!"
        id="add-ticket-detail"
        type="button"
        [style]="'primary-alt'"
        buttonSize="small"
        (click)="addDetail()">
        <span class="material-symbols-rounded mr-1 text-lg!" aria-hidden="true">
          add
        </span>
        {{ cmsTextProvider.sortiment.newDetails }}
      </aw-button>
    </div>
    <div class="w-1/2">
      <aw-translation-text-input
        class="block w-full"
        id="ticket-details-title"
        [entityType]="EntityType.ticketButton"
        [relationType]="TextRelationType.button"
        [formControl]="sortimentForm().controls.buttonText"
        [label]="cmsTextProvider.sortiment.nameOfTicketActionButton" />
    </div>
  </aw-section>
</div>
